import MESSAGES from "../../../../../../appMessages";
import MapsHelper from "../../../../../../lib/Map/helper";
import Events from "../../../../../../utilities/EventEmitter";
import drawConstant from "../../../common/DrawTools/DrawConstant";

export const getExistingFeaturesGeoJSON = (dropYards) => {
  if (!dropYards?.length) {
    return [];
  }
  return dropYards
    .filter((dropYard) => isDropYardHaveRegion(dropYard))
    .map((dropYard) => {
      const { dropYardId, boundary } = dropYard;
      return {
        id: dropYardId,
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [boundary],
        },
      };
    });
};

export const isDropYardHaveRegion = (dropYard) => {
  return dropYard?.boundary?.length > 0;
};

export const getFormattedDropYardData = (dropYard) => {
  return {
    id: dropYard.dropYardId,
    regionId: dropYard.dropYardRegionId || null,
    code: dropYard.dropYardCode,
    terminalId: dropYard.terminalId,
    terminalCode: dropYard.terminalCode,
    name: dropYard.dropYardName,
    trailers: (dropYard.trailerInventory ?? []).map((trailer) => ({
      id: trailer.trailerId,
      name: trailer.trailerName,
      count: trailer.eqptCount,
    })),
    tractors: (dropYard.tractorInventory ?? []).map((tractor) => ({
      id: tractor.tractorId,
      name: tractor.tractorName,
      count: tractor.eqptCount,
    })),
    boundary: dropYard.boundary,
  };
};

export const getDropYardSavePayload = (data) => {
  return {
    dropYardId: data.id,
    dropYardRegionId: data.regionId || null,
    terminalId: data.terminalId,
    terminalCode: data.terminalCode,
    dropYardTrailerInventory: data.trailers.map((trailer) => ({
      trailerId: trailer.id,
      eqptCount: trailer.count,
    })),
    dropYardTractorInventory: data.tractors.map((tractor) => ({
      tractorId: tractor.id,
      eqptCount: tractor.count,
    })),
    boundary: data.boundary,
  };
};

export const getDropYardsWithinRegion = (feature, dropYardList) => {
  const dropYardsWithinRegion = MapsHelper.getLocationWithinBounds(
    feature?.geometry?.coordinates,
    dropYardList
  );
  return dropYardsWithinRegion;
};

export const checkErrorInRegion = ({
  feature,
  dropYardsWithinRegion,
  geoDataList,
}) => {
  const dropYardsWithinCount = dropYardsWithinRegion?.length ?? 0;
  if (dropYardsWithinCount === 0) {
    return MESSAGES.DROP_YARDS.NO_DROP_YARD_WITHIN_REGION;
  } else if (dropYardsWithinCount > 1) {
    return MESSAGES.DROP_YARDS.MULTIPLE_DROP_YARDS_WITHIN_REGION;
  } else if (MapsHelper.checkIfOverlappingRegions(geoDataList, feature)) {
    return MESSAGES.DROP_YARDS.DROP_YARD_REGION_OVERLAPPING;
  } else if (isDropYardHaveRegion(dropYardsWithinRegion[0])) {
    return MESSAGES.DROP_YARDS.DROP_YARD_REGION_ALREADY_EXISTS;
  }
};

export const finishDrawing = () => {
  Events.emit(
    drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP,
    "cancel",
    true
  );
};
